define('lq/timeout',[
	'underscore'
], function (_) {

	function Timeout() {
		this.timeoutIds = null;
	}

	Timeout.prototype.set = function (handler, timeout) {
		var self = this;
		var timeoutId = setTimeout(function () {
			self.timeoutIds = _.filter(self.timeoutIds, function (otherTimeoutId) {
				return otherTimeoutId  !== timeoutId;
			});
			handler();
		}, timeout);

		if (!this.timeoutIds)
			this.timeoutIds = [timeoutId];
		else
			this.timeoutIds.push(timeoutId);

		return timeoutId;
	};

	Timeout.prototype.cleanUp = function () {
		_.each(this.timeoutIds, function (timeoutId) {
			clearTimeout(timeoutId);
		});
		this.timeoutIds = null;
	};

	return Timeout;

});
